import React from 'react';

import ActivityIndicator from '@components/ActivityIndicator';
import type { ErrorProps } from '@components/ErrorView';
import Placeholder from '@components/Placeholders';
import ScreenContainer, { ScreenContainerSafeAreaProvider } from '@components/ScreenContainer';

export type AppErrorScreenProps = {
  errorProps?: ErrorProps;
};

export function AppLoadingScreen() {
  return (
    <ScreenContainerSafeAreaProvider>
      <ScreenContainer testID="navigation.AppLoadingScreen.ScreenContainer">
        <Placeholder logo title="Joinstar" />
        <ActivityIndicator size="large" />
      </ScreenContainer>
    </ScreenContainerSafeAreaProvider>
  );
}

export function AppErrorScreen({ errorProps }: AppErrorScreenProps) {
  return (
    <ScreenContainerSafeAreaProvider>
      <ScreenContainer
        error={true}
        errorProps={{
          message: 'Please check your network connection.',
          tapToReload: true,
          ...errorProps,
        }}
        testID="navigation.AppErrorScreen.ScreenContainer"
      />
    </ScreenContainerSafeAreaProvider>
  );
}
